import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import ComponentErrorBoundary from '../../../components/component-error-boundary';

export default function Tags(props) {
  return (
    <div>
    <ComponentErrorBoundary value="select rule autocomplete">
      <Autocomplete
        autoHighlight
        disableClearable={true}
        options={props.fileColumns}
        disabled={props.disabled===undefined?false:props.disabled}
        getOptionLabel={option => option.name || option }
        isOptionEqualToValue={(option,value) => option.id === value.id}
        value={props.value}
        onChange={(event, newValue) => {props.onSelectValue(newValue);}}
        renderInput={params => {
          return (
            <TextField
              {...params}
              variant="standard"
              label={props.label}
              fullWidth
            />
          );
        }}
      />
      </ComponentErrorBoundary>
    </div>
  );
}
